import { jsPDF } from 'jspdf'
import moment from 'moment';
import { autoTable } from 'jspdf-autotable'

//export const generateDailyPlanPDF = (pickups, returns, isTomorrow = false) => {
export const generateDailyPlanPDF = (pickups, returns, isTomorrow) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const date = moment().add(isTomorrow ? 1 : 0, 'days').format('MMMM D, YYYY');

  // Add title and date
  doc.setFontSize(20);
  doc.text(`${isTomorrow ? "Tomorrow's" : "Daily"} Rental Plan`, pageWidth / 2, 15, { align: 'center' });
  doc.setFontSize(12);
  doc.text(date, pageWidth / 2, 25, { align: 'center' });

  // Pickups section
  doc.setFontSize(16);
  doc.setTextColor(34, 197, 94); // green-600
  doc.text('Vehicles to Hand Over', 14, 40);

  if (pickups.length > 0) {
    autoTable(doc, {
        startY: 45,
        head: [['Time', 'Vehicle', 'Customer', 'Contact', 'Location']],
        body: pickups.map(rental => [
            moment(rental.pickupDateTime).format('HH:mm'),
            rental.carName,
            `${rental.customer.firstName} ${rental.customer.lastName}`,
            rental.customer.phoneNumber,
            rental.pickupLocation
        ]),
        theme: 'grid',
        headStyles: { 
            fillColor: [34, 197, 94],
            textColor: 255
        },
        styles: { 
            fontSize: 10,
            cellPadding: 3
        }
        });
  } else {
    doc.setFontSize(12);
    doc.text('No vehicle handovers scheduled for today.', 14, 50);
  }

  // Returns section
  const returnsY = pickups.length > 0 ? doc.lastAutoTable.finalY + 20 : 70;
  doc.setFontSize(16);
  doc.setTextColor(59, 130, 246); // blue-600
  doc.text('Expected Returns', 14, returnsY);

  if (returns.length > 0) {
    autoTable(doc, {
      startY: returnsY + 5,
      head: [['Time', 'Vehicle', 'Customer', 'Contact', 'Location']],
      body: returns.map(rental => [
        moment(rental.returnDateTime).format('HH:mm'),
        rental.carName,
        `${rental.customer.firstName} ${rental.customer.lastName}`,
        rental.customer.phoneNumber,
        rental.returnLocation
      ]),
      theme: 'grid',
      headStyles: { 
        fillColor: [59, 130, 246],
        textColor: 255
      },
      styles: { 
        fontSize: 10,
        cellPadding: 3
      }
    });
  } else {
    doc.setFontSize(12);
    doc.text('No vehicle returns scheduled for today.', 14, returnsY + 10);
  }

  // Add page number at the bottom
  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(10);
  doc.setTextColor(100);
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
  }

  // Save the PDF
  const fileDate = moment().add(isTomorrow ? 1 : 0, 'days').format('YYYY-MM-DD');
  doc.save(`Daily-Plan-${fileDate}.pdf`);
};